module.exports = __webpack_public_path__ + "static/media/19.170a1406.jpg";